import type { CartCardData } from "./validate";
import { handleCardCtaClick } from "../../MobileApp/webviewBridge";
export type { CartCardData } from "./validate";

export function formatTotal(amount: number): string {
  return Number.isInteger(amount) ? `$${amount}` : `$${amount.toFixed(2)}`;
}

export function formatPrice(quantity: number, price: number): string {
  const formatted = Number.isInteger(price) ? `$${price}` : `$${price.toFixed(2)}`;
  return quantity > 1 ? `${quantity} × ${formatted}` : formatted;
}

interface CartCardProps {
  data: CartCardData;
}

export function CartCard({ data }: CartCardProps) {
  return (
    <div className="lk-cart-card">
      <div className="lk-cart-card-header">
        <span className="lk-cart-card-title">Your Cart</span>
        <span className="lk-cart-card-badge">
          {data.items.length} item{data.items.length !== 1 ? "s" : ""}
        </span>
      </div>
      <div className="lk-cart-card-items">
        {data.items.map((item, i) => (
          <div className="lk-cart-card-item" key={i}>
            <div
              className="lk-cart-card-thumb"
              style={item.imageUrl ? { backgroundImage: `url(${item.imageUrl})` } : undefined}
            />
            <div className="lk-cart-card-item-info">
              <div className="lk-cart-card-item-name">{item.productTitle}</div>
              {item.variantTitle && item.variantTitle !== "Default Title" && (
                <div className="lk-cart-card-item-variant">{item.variantTitle}</div>
              )}
            </div>
            <div className="lk-cart-card-item-price">
              {formatPrice(item.quantity, item.price)}
            </div>
          </div>
        ))}
      </div>
      <div className="lk-cart-card-footer">
        <div className="lk-cart-card-total-row">
          <span className="lk-cart-card-total-label">Total</span>
          <span className="lk-cart-card-total">{formatTotal(data.totalAmount)}</span>
        </div>
        <a
          className="lk-cart-card-cta"
          href={data.checkoutUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => handleCardCtaClick(e, data.checkoutUrl, "checkout")}
        >
          {data.ctaLabel ?? `Checkout on ${data.storeDomain ?? `${data.brand}.com`}`}
        </a>
      </div>
    </div>
  );
}
